import { useState } from 'react'

import { useCheckOperation } from '@builddocs/data-management'
import { Box, Divider, Stack, Typography } from '@mui/material'
import Button from '@mui/material/Button'

import CommentHistoryCard from './CommentHistoryCard'
import { useCommentsHistory } from './query/useCommentsHistory'
import { useRestoreCommentsFromHistory } from './query/useRestoreCommentsFromHistory'

interface CommentsHistoryListProps {
  externalId: string
  externalEntityInfo: string
  refreshComments: () => void
}

export default function CommentsHistoryList({
  externalId,
  externalEntityInfo,
  refreshComments,
}: CommentsHistoryListProps) {
  const [selectedComments, setSelectedComments] = useState<string[]>([])
  const [selecting, setSelecting] = useState(false)
  const { data: comments } = useCommentsHistory({
    externalId,
    externalEntityInfo,
  })

  const { mutate: restoreComments } = useRestoreCommentsFromHistory({
    externalId,
    externalEntityInfo,
  })

  const { checkOperation } = useCheckOperation()

  const handleRestoreComments = () => {
    restoreComments(
      {
        commentIds: selectedComments,
      },
      {
        onSuccess: () => refreshComments(),
      },
    )
  }

  const handleRestoreCommentsClick = () => {
    checkOperation({
      operationId: 'MOVE_REMARK_TO_ACT',
      operationCallback: handleRestoreComments,
    })
  }

  const handleCommentSelect = id => {
    if (selectedComments.includes(id)) {
      setSelectedComments(prev => prev.filter(prevId => prevId !== id))
    } else {
      setSelectedComments(prev => [...prev, id])
    }
  }

  const handleSetSelect = (val: boolean) => () => setSelecting(val)

  // const refreshComments = () => {}

  return comments?.length ? (
    <Stack direction="column" gap={2}>
      <Stack direction="row" justifyContent="space-between">
        <Typography gutterBottom variant="h6">
          История замечаний
        </Typography>
        {selecting ? (
          <Stack direction="row" gap={1}>
            <Button
              disabled={!selectedComments?.length}
              onClick={handleRestoreCommentsClick}
            >
              Перенести в акт
            </Button>
            <Button onClick={handleSetSelect(false)}>Отмена</Button>
          </Stack>
        ) : (
          <Button onClick={handleSetSelect(true)}>Выбрать</Button>
        )}
      </Stack>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        {comments?.map(c => (
          <>
            <CommentHistoryCard
              key={c.commentId}
              comment={c}
              selected={selectedComments.includes(c?.commentId)}
              selecting={selecting}
              onSelect={() => handleCommentSelect(c.commentId)}
            />
            <Divider sx={{ marginBottom: '8px' }} />
          </>
        ))}
      </Box>
    </Stack>
  ) : null
}
